import { render, staticRenderFns } from "./PrettyProTable.vue?vue&type=template&id=b723e496&scoped=true"
import script from "./PrettyProTable.vue?vue&type=script&lang=js"
export * from "./PrettyProTable.vue?vue&type=script&lang=js"
import style0 from "./PrettyProTable.vue?vue&type=style&index=0&id=b723e496&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b723e496",
  null
  
)

export default component.exports